<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Doctor License Renewal
                       
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">  
                            <table 	datatable [dtOptions]="dtOptions" *ngIf="dtRender"
                            class="table table-striped table-bordered table-sm" style="width: 100%; font-size: 12px;">
                                <thead style="background-color: #1cadc7 !important; color: white;">
                                    <tr>
                                       <th>S.No</th>
                                       <th>Doctor Name</th>
                                       <th>Hospital name</th>
                                       <th>OTP</th>
                                       <th>Location</th>
                                       <th>License Start Date</th>
                                       <th>License End Date</th>
                                        <th class="text-center" style="width:12%;">Actions</th>
                                    </tr>
                                </thead>
                                <tbody >
                                 
                                    <tr *ngFor="let item of doctorList;let i=index;">
                                        <td>{{i+1}}</td>
                                        <td>{{item?.doctor_name}}</td>
                                        <td>{{item?.hospital_name}}</td>
                                        <td>{{item?.renewal_otp?item?.renewal_otp : item?.otp}}</td>
                                        <td>
                                           <div class="d-flex align-items-center gap-1">
                                             <select class="form-control form-control-sm me-2"
                                              style="width: auto;width: 200px;"  *ngIf="item?.otp"
                                              [(ngModel)]="item.location_id">
                                              <option [ngValue]="null">Select</option>
                                              <option *ngFor="let status of locationLst" [ngValue]="status.id">{{status.location}}</option>
                                              </select>

                                              <input type="button" *ngIf="item?.location_id" class="btn btn-sm btn-primary ml-2" value="Go" (click)="onLocationChange(item)">
                                            </div>
                                        </td>
                                        <td>{{item?.license_start_date}}</td>
                                        <td>{{item?.license_end_date}}</td>
                                        <td *ngIf="item.license_start_date"><button type="button" class="btn btn-sm btn-info" id="rzp-button1" (click)="getOrderId(item)">Renewal</button></td>
                                        <td *ngIf="!item.license_start_date"><button type="button" class="btn btn-sm btn-info" id="rzp-button1" (click)="getOrderId(item)">Get License </button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>